import CfSideMenu from '@/components/common/sideMenu/CfSideMenu.vue'

import MCF_SC_001 from '@/views/cf/MCF_SC_001.vue'
import MCF_SC_002 from '@/views/cf/MCF_SC_002.vue'
import MCF_SC_003 from '@/views/cf/MCF_SC_003.vue'
import MCF_SC_005 from '@/views/cf/MCF_SC_005.vue'
import MCF_SC_007 from '@/views/cf/MCF_SC_007.vue'
import MCF_SC_004 from '@/views/cf/MCF_SC_004.vue'
import MCF_SC_006 from '@/views/cf/MCF_SC_006.vue'
import MCF_SC_008 from '@/views/cf/MCF_SC_008.vue'
import MCF_US_001 from '@/views/cf/MCF_US_001.vue'
import MCF_US_002 from '@/views/cf/MCF_US_002.vue'
import MCF_US_003 from '@/views/cf/MCF_US_003.vue'
import MCF_US_004 from '@/views/cf/MCF_US_004.vue'
import MCF_DP_001 from '@/views/cf/MCF_DP_001.vue'
import MCF_MN_001 from '@/views/cf/MCF_MN_001.vue'
import MCF_PR_001 from '@/views/cf/MCF_PR_001.vue'
import MCF_CD_001 from '@/views/cf/MCF_CD_001.vue'
import MCF_BT_001 from '@/views/cf/MCF_BT_001.vue'
import MCF_BT_002 from '@/views/cf/MCF_BT_002.vue'
import MCF_BT_003 from '@/views/cf/MCF_BT_003.vue'
import MCF_BT_004 from '@/views/cf/MCF_BT_004.vue'
import MCF_BT_005 from '@/views/cf/MCF_BT_005.vue'
import MCF_AM_001 from '@/views/cf/MCF_AM_001.vue'
import MCF_AM_002 from '@/views/cf/MCF_AM_002.vue'

import MCF_NT_001 from '@/views/cf/MCF_NT_001.vue'  // 공지사항 등록
import MCF_NT_002 from '@/views/cf/MCF_NT_002.vue'  // 공지사항 리스트 조회
import MCF_NT_003 from '@/views/cf/MCF_NT_003.vue'  // 공지사항 리스트 상세조회
import MCF_NT_004 from '@/views/cf/MCF_NT_004.vue'  // 공지사항 수정


//설정화면 라우터
const settingRouter = [
     
    /* 화면명 : 영업기회 속성관리  : MCF_SC_001  */
    {
        path: "/cf/MCF_SC_001", 
        name : 'MCF_SC_001',
        components: {
            default : MCF_SC_001,
            sideMenu : CfSideMenu
        },
        meta :{
            title: '영업기회 속성 관리',
            IADepth: ['설정', '영업기회 설정', '영업기회 속성 관리']
        }
    },


     /* 화면명 : 영업기회 Quota 등록 : MCF_SC_002  */
     {
        path: "/cf/MCF_SC_002", 
        name : 'MCF_SC_002',
        components: {
            default : MCF_SC_002,
            sideMenu : CfSideMenu
        },
        meta :{
            title: '영업기회 Quota 등록',
            IADepth: ['설정', '영업기회 설정', '영업기회 Quota 등록']
        }
    },

     /* 화면명 : 영업기회 Quota 수정  : MCF_SC_003  */
     {
        path: "/cf/MCF_SC_003", 
        name : 'MCF_SC_003',
        components: {
            default : MCF_SC_003,
            sideMenu : CfSideMenu
        },
        meta :{
            title: '영업기회 Quota 수정',
            IADepth: ['설정', '영업기회 설정', '영업기회 Quota 수정']
        }
    },

      /* 화면명 : 영업기회 Quota 수정  : MCF_SC_003  */
      {
        path: "/cf/MCF_SC_007", 
        name : 'MCF_SC_007',
        components: {
            default : MCF_SC_007,
            sideMenu : CfSideMenu
        },
        meta :{
            title: '영업기회 Quota 조회',
            IADepth: ['설정', '영업기회 설정', '영업기회 Quota 조회']
        }
    },

     /* 화면명 : 영업기회 Quota 일괄등록  : MCF_SC_005  */
     {
        path: "/cf/MCF_SC_005", 
        name : 'MCF_SC_005',
        components: {
            default : MCF_SC_005,
            sideMenu : CfSideMenu
        },
        meta :{
            title: '영업기회 Quota 일괄등록',
            IADepth: ['설정', '영업기회 설정', '영업기회 Quota 일괄등록']
        }
    },

     /* 화면명 : account 매핑테이블 수정  : MCF_SC_004  */
     {
        path: "/cf/MCF_SC_004", 
        name : 'MCF_SC_004',
        components: {
            default : MCF_SC_004,
            sideMenu : CfSideMenu
        },
        meta :{
            title: 'Account 매핑테이블 등록/수정',
            IADepth: ['설정', '영업기회 설정', 'Account 매핑테이블 등록/수정']
        }
    },

    /* 화면명 : account 매핑테이블 조회  : MCF_SC_008  */
    {
        path: "/cf/MCF_SC_008", 
        name : 'MCF_SC_008',
        components: {
            default : MCF_SC_008,
            sideMenu : CfSideMenu
        },
        meta :{
            title: 'Account 매핑테이블 조회',
            IADepth: ['설정', '영업기회 설정', 'Account 매핑테이블 조회']
        }
    },

    /* 화면명 : account 매핑테이블 이력 조회  : MCF_SC_006  */
    {
        path: "/cf/MCF_SC_006", 
        name : 'MCF_SC_006',
        components: {
            default : MCF_SC_006,
            sideMenu : CfSideMenu
        },
        meta :{
            title: 'Account 매핑테이블 이력 조회',
            IADepth: ['설정', '영업기회 설정', 'Account 매핑테이블 이력 조회']
        }
    },

     /* 화면명 : 사용자 조회  : MCF_US_001  */
     {
        path: "/cf/MCF_US_001", 
        name : 'MCF_US_001',
        components: {
            default : MCF_US_001,
            sideMenu : CfSideMenu
        },
        meta :{
            title: '사용자 조회',
            IADepth: ['설정', '사용자 관리', '사용자 조회']
        }
    },

     /* 화면명 : 사용자 등록  : MCF_US_002  */
     {
        path: "/cf/MCF_US_002", 
        name : 'MCF_US_002',
        components: {
            default : MCF_US_002,
            sideMenu : CfSideMenu
        },
        meta :{
            title: '사용자 등록',
            IADepth: ['설정', '사용자 관리', '사용자 등록']
        }
    },
    
    /* 화면명 : 사용자 상세조회  : MCF_US_004  */
    {
        path: "/cf/MCF_US_004", 
        name : 'MCF_US_004',
        components: {
            default : MCF_US_004,
            sideMenu : CfSideMenu
        },
        meta :{
            title: '사용자 상세조회',
            IADepth: ['설정', '사용자 관리', '사용자 상세조회']
        }
    },

    /* 화면명 : 사용자 수정  : MCF_US_003  */
    {
        path: "/cf/MCF_US_003", 
        name : 'MCF_US_003',
        components: {
            default : MCF_US_003,
            sideMenu : CfSideMenu
        },
        meta :{
            title: '사용자 수정',
            IADepth: ['설정', '사용자 관리', '사용자 수정']
        }
    },

     /* 화면명 : 부서관리  : MCF_DP_001  */
     {
        path: "/cf/MCF_DP_001", 
        name : 'MCF_DP_001',
        components: {
            default : MCF_DP_001,
            sideMenu : CfSideMenu
        },
        meta :{
            title: '부서관리',
            IADepth: ['설정', '부서관리']
        }
    },

     /* 화면명 : 화면 메뉴관리  : MCF_MN_001  */
     {
        path: "/cf/MCF_MN_001", 
        name : 'MCF_MN_001',
        components: {
            default : MCF_MN_001,
            sideMenu : CfSideMenu
        },
        meta :{
            title: '화면 메뉴 관리',
            IADepth: ['설정', '화면 메뉴 관리']
        }
    },

     /* 화면명 : 화면 권한관리 : 권한그룹  : MCF_PR_001  */
     {
        path: "/cf/MCF_PR_001", 
        name : 'MCF_PR_001',
        components: {
            default : MCF_PR_001,
            sideMenu : CfSideMenu
        },
        meta :{
            title: '화면 권한 관리',
            IADepth: ['설정', '화면 권한 관리']
        }
    },

     /* 화면명 : 공통 코드관리  : MCF_CD_001  */
     {
        path: "/cf/MCF_CD_001", 
        name : 'MCF_CD_001',
        components: {
            default : MCF_CD_001,
            sideMenu : CfSideMenu
        },
        meta :{
            title: '코드관리',
            IADepth: ['설정', '코드관리']
        }
    },

     /* 화면명 : 배치 프로시저 관리  : MCF_BT_001  */
     {
        path: "/cf/MCF_BT_001", 
        name : 'MCF_BT_001',
        components: {
            default : MCF_BT_001,
            sideMenu : CfSideMenu
        },
        meta :{
            title: '배치 프로시저 관리',
            IADepth: ['설정', '배치 관리', '배치 프로시저 관리']
        }
    },

     /* 화면명 : 배치 프로시저 등록  : MCF_BT_002  */
     {
        path: "/cf/MCF_BT_002", 
        name : 'MCF_BT_002',
        component: () => import('../views/cf/MCF_BT_002.vue'),
        components: {
            default : MCF_BT_002,
            sideMenu : CfSideMenu
        },
        meta :{
            title: '스케줄러 이력 조회',
            IADepth: ['설정', '배치 관리', '스케줄러 이력 조회']
        }
    },

     /* 화면명 : 스케줄러 이력 조회  : MCF_BT_003  */
     {
        path: "/cf/MCF_BT_003", 
        name : 'MCF_BT_003',
        components: {
            default : MCF_BT_003,
            sideMenu : CfSideMenu
        },
        meta :{
            title: '스케줄러 이력 조회',
            IADepth: ['설정', '배치 관리', '스케줄러 이력 조회']
        }
    },

    /* 화면명 : 배치 결과 조회  : MCF_BT_004  */
    {
        path: "/cf/MCF_BT_004", 
        name : 'MCF_BT_004',
        components: {
            default : MCF_BT_004,
            sideMenu : CfSideMenu
        },
        meta :{
            title: '배치 결과 조회',
            IADepth: ['설정', '배치 관리', '배치 결과 조회']
        }
    },

     /* 화면명 : 배치 결과 조회  : MCF_BT_004  */
     {
        path: "/cf/MCF_BT_005", 
        name : 'MCF_BT_005',
        components: {
            default : MCF_BT_005,
            sideMenu : CfSideMenu
        },
        meta :{
            title: '상품 오류 기입',
            IADepth: ['설정', '배치 관리', '배치 결과 조회']
        }
    },

    /* 화면명 : 영업기회 알림  : MCF_AM_001  */
    {
        path: "/cf/MCF_AM_001", 
        name : 'MCF_AM_001',
        components: {
            default : MCF_AM_001,
            sideMenu : CfSideMenu
        },
        meta :{
            title: '영업기회 알림',
            IADepth: ['설정', '알림결과 조회', '영업기회 알림']
        }
    },

    /* 화면명 : 메일발신 이력  : MCF_AM_002  */
    {
        path: "/cf/MCF_AM_002", 
        name : 'MCF_AM_002',
        components: {
            default : MCF_AM_002,
            sideMenu : CfSideMenu
        },
        meta :{
            title: '메일발신 이력',
            IADepth: ['설정', '알림결과 조회', '메일발신 이력']
        }
    },

     /* 화면명 : New&Report 등록  : MCF_NT_001  */
     {
        path: "/cf/MCF_NT_001", 
        name : 'MCF_NT_001',
        components: {
            default : MCF_NT_001,
            sideMenu : CfSideMenu
        },
        meta :{
            title: 'News&Notice 등록/수정',
            IADepth: ['설정', 'News&Notice 등록/수정']
        }
    },

     /* 화면명 : New&Report 조회  : MCF_NT_002  */
     {
        path: "/cf/MCF_NT_002", 
        name : 'MCF_NT_002',
        components: {
            default : MCF_NT_002,
            sideMenu : CfSideMenu
        },
        meta :{
            title: 'News&Notice 조회',
            IADepth: ['설정', 'News&Notice 조회']
        }
    },

    /* 화면명 : New&Report 상세조회  : MCF_NT_003  */
    {
        path: "/cf/MCF_NT_003", 
        name : 'MCF_NT_003',
        components: {
            default : MCF_NT_003,
            sideMenu : CfSideMenu
        },
        meta :{
            title: 'News&Notice 상세조회',
            IADepth: ['설정', 'News&Notice 상세조회']
        }
    },
        
    /* 화면명 : New&Report 수정  : MCF_NT_004  */
    {
        path: "/cf/MCF_NT_004", 
        name : 'MCF_NT_004',
        components: {
            default : MCF_NT_004,
            sideMenu : CfSideMenu
        },
        meta :{
            title: 'News&Notice 수정',
            IADepth: ['설정', 'News&Notice 수정']
        }
    },



 

]
export {settingRouter}